module.exports = __webpack_public_path__ + "linkedin-white.svg?4569f04dc315e5f7f84603b0e1f824fd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/social-media/linkedin-white.svg
// module id = 37
// module chunks = 0